import { apiDelete, apiGet, apiPost, apiPut } from "./http";
import type { FanTopicDto } from "./types";

/** 平台运营管理端：全平台球迷话题（与租户无关）。 */
export function fetchFanTopicsForPlatform() {
  return apiGet<FanTopicDto[]>(`/api/platform/fan-topics`);
}

export function postFanTopic(body: { name: string; colorGradient?: string }) {
  return apiPost<FanTopicDto>(`/api/platform/fan-topics`, body);
}

export function patchFanTopic(topicId: number, body: { name?: string; colorGradient?: string }) {
  return apiPut<FanTopicDto>(`/api/platform/fan-topics/${topicId}`, body);
}

export function deleteFanTopic(topicId: number) {
  return apiDelete(`/api/platform/fan-topics/${topicId}`);
}
